"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Popover = _interopRequireDefault(require("../Popover"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var More =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(More, _Component);

  function More(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      status: false
    };
    _this.changeStatus = _this.changeStatus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = More.prototype;

  _proto.changeStatus = function changeStatus(status) {
    this.setState({
      status: status
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        data = _this$props.data,
        className = _this$props.className,
        popoverClassName = _this$props.popoverClassName,
        contentClassName = _this$props.contentClassName,
        dataId = _this$props.dataId,
        trigger = _this$props.trigger,
        compressed = _this$props.compressed,
        cls = _this$props.cls;
    var status = this.state.status;
    if (data.length <= 1) return data;
    var firstItem = data[0],
        items = data.slice(1);
    var itemsLength = items.length;
    return _react.default.createElement("a", {
      tabIndex: -1,
      key: "more",
      className: (0, _classnames.default)(className, cls && status && cls('item-more'))
    }, _react.default.createElement("span", null, "+" + itemsLength), _react.default.createElement(_Popover.default, {
      showArrow: false,
      trigger: trigger,
      visible: status,
      onVisibleChange: this.changeStatus,
      className: popoverClassName
    }, _react.default.createElement("div", {
      className: contentClassName,
      "data-id": dataId
    }, compressed === 'no-repeat' ? null : firstItem, items)));
  };

  return More;
}(_react.Component);

More.defaultProps = {
  trigger: 'hover'
};
More.propTypes = {
  className: _propTypes.default.string,
  data: _propTypes.default.array,
  popoverClassName: _propTypes.default.string,
  contentClassName: _propTypes.default.string,
  dataId: _propTypes.default.string,
  trigger: _propTypes.default.string,
  compressed: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
  cls: _propTypes.default.func
};
var _default = More;
exports.default = _default;